import { createApp } from 'vue';
import { createRouter, createWebHistory } from 'vue-router';
import App from './App.vue';
import { Icon } from '@iconify/vue';

// Import base.js for menu and video functionality
import './base.js';

// Import pages
import Home from './pages/Home.vue';
import About from './pages/About.vue';
import Inventory from './pages/Inventory.vue';
import CarDetail from './pages/CarDetail.vue';
import CarOnRequest from './pages/CarOnRequest.vue';
import Contacts from './pages/Contacts.vue';
import SoldCars from './pages/SoldCars.vue';
import Services from './pages/Services.vue';
import Brands from './pages/Brands.vue';
import BrandDetail from './pages/BrandDetail.vue';
import ExportDestinations from './pages/ExportDestinations.vue';
import ExportDestination from './pages/ExportDestination.vue';
import NotFound from './pages/NotFound.vue';

// Create router
const routes = [
  { path: '/', component: Home },
  { path: '/about', component: About },
  { path: '/inventory', component: Inventory },
  { path: '/sold-cars', component: SoldCars },
  { path: '/car/:id', component: CarDetail },
  { path: '/car/:make/:model/:year/:id', component: CarDetail },
  { path: '/car-on-request', component: CarOnRequest },
  { path: '/services', component: Services },
  { path: '/contacts', component: Contacts },
  // Brand pages
  { path: '/brands', component: Brands },
  { path: '/brands/:slug', component: BrandDetail },
  // Export destination pages
  { path: '/export', component: ExportDestinations },
  { path: '/export/:country', component: ExportDestination },
  // 404 catch-all — must be last
  { path: '/:pathMatch(.*)*', name: 'NotFound', component: NotFound },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return { top: 0 };
  },
});

// Create and mount the app
const app = createApp(App);
app.use(router);

// Register Iconify component globally
app.component('Icon', Icon);

app.mount('#app');
